/**
 * Input
 */

// Custom
import 'protons';
import $ from 'jquery';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.de.min';
import '../select';

// Module template
import './_input.twig';

// Import custom sass, includes Bootstrap sass
import './_input.scss';

export const name = 'input';

export function disable() {}

export function enable($context) {
  $('.input-password', $context).each(function eachFormGroupPassword() {
    const $this = $(this);
    const passwordVisibleClass = 'is-showing-password';
    const $input = $this.find('input');
    const $icon = $this.find('.input-password__icon');
    let showing = false;

    const togglePassword = show => {
      showing = show;
      $this.toggleClass(passwordVisibleClass, show);
      $input.attr('type', show ? 'text' : 'password');
    };

    $icon.click(() => togglePassword(!showing));
  });

  $('.form-file', $context).each(function eachFileValueEl() {
    const $this = $(this);
    const $label = $this.siblings('label');
    const defaultText = $label.text();
    const updateLabel = () => {
      const fileList = Array.from($this.get(0).files);
      $label.text(
        fileList.length === 0
          ? defaultText
          : fileList.map(file => file.name).join(', ')
      );
    };
    $this.on('change', updateLabel);
    updateLabel();
  });

  const dateTimeSelector = '.all-events-filter .input--date';
  $.fn.datepicker.defaults.format = 'mm/dd/yyyy';
  $.fn.datepicker.defaults.orientation = 'bottom';
  $.fn.datepicker.defaults.autoclose = true;
  $.fn.datepicker.defaults.language =
    window.drupalSettings.path.currentLanguage;

  $(dateTimeSelector).datepicker();
  $(dateTimeSelector).on('changeDate', function onChangeDateFn() {
    $(this)
      .closest('form')
      .find('[data-bef-auto-submit-click]')
      .click();
  });
  // If we are in a mobile device, add readonly attribute so the keyboard
  // won't appear when focus.
  if (
    typeof window.orientation !== 'undefined' ||
    navigator.userAgent.indexOf('IEMobile') !== -1
  ) {
    $(dateTimeSelector, $context).attr('readonly', 'readonly');
  }
}

export default enable;


// This is automatically added by drupal-behaviors-loader
Drupal.behaviors[name] = {
  attach: enable,
  detach: disable,
};